<template>
  <section class="signature-answered">
    <UnifiedFilterSearch
      :filterList="filterList"
      :itensFilter="itensFilter"
      :activeTab="activeTab"
      isNotOpenStackeholderSearch
      bookmarkType="bookmarks_answered"
      :tabPersistName="tabPersistName"
      @search-value="setSearchValue"
      @filters="setFilterList"
    />

    <div class="level">
      <div class="level-left has-text-left">
        <span class="has-text-weight-semibold">
          {{ getPaginationDetails }}
        </span>
      </div>
    </div>
    <div v-if="observerPage" class="middle">
      <b-table
        class="custom-table-process-panel custom-6-columns-signing"
        :data="isLoading ? [] : getDocumentSignedSignList.list"
        :sortIcon="sortIcon"
        :sortIconSize="sortIconSize"
        :checkedRows.sync="documentsSelectedSigned"
        :aria-next-label="General.NEXT_PAGE"
        :aria-previous-label="General.PREVIOUS_PAGE"
        :aria-page-label="General.PAGE"
        :aria-current-label="General.CURRENT_PAGE"
        :defaultSortDirection="defaultSortOrder"
        :defaultSort="[sortField, sortOrder]"
        backendSorting
        hoverable
        role="table"
        @sort="onSort"
      >
        <template>
          <b-table-column v-slot="props">
            <div class="is-flex">
              <b-tooltip
                v-if="isConfidential(props.row)"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                position="is-right"
                :label="secrecyName(props.row)"
                class="ml-5"
                role="tooltip"
              >
                <div class="circle-red">
                  <b-icon
                    type="is-white"
                    icon="lock"
                    customSize="mdi-inherit"
                  />
                </div>
              </b-tooltip>
              <b-tooltip
                v-if="
                  props.row.process_file.process.priority &&
                    subjectIcons[props.row.process_file.process.priority.type]
                "
                :label="props.row.process_file.process.priority.name"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                position="is-right"
              >
                <b-icon
                  v-if="
                    props.row.process_file.process.subject &&
                      subjectIcons[props.row.process_file.process.priority.type]
                  "
                  :type="
                    subjectIcons[props.row.process_file.process.priority.type]
                      .color
                  "
                  :icon="
                    subjectIcons[props.row.process_file.process.priority.type]
                      .icon
                  "
                />
              </b-tooltip>
              <b-tooltip
                :label="General.TEXTS.PROCESS_APPENDER"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                role="tooltip"
                position="is-right"
              >
                <b-icon
                  v-if="props.row.process_file.process.process_join_set"
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  icon="link-variant"
                />
              </b-tooltip>
            </div>
          </b-table-column>
          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="process_file__process__nup"
            :label="General.NUP"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{
                Number(props.row.process_file.process.nup) > 0
                  ? applyMaskNUP(props.row.process_file.process.nup)
                  : General.TEXTS.NUP_NOT_GENERATED
              }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="process_file__attachment_name"
            :label="General.DOCUMENT"
            :sortable="!isMobile"
          >
            <div class="has-text-left">
              <routerLink
                class="has-text-color-8 has-text-weight-semibold is-size-6 custom-pointer"
                role="link"
                rel="search tag"
                :to="
                  `/app/documento/${props.row.process_file.id}?processId=${props.row.process_file.process.id}`
                "
              >
                <b-tooltip
                  :label="props.row.process_file.attachment_name"
                  :type="isContrast ? 'is-white' : 'is-blue-oil'"
                  :active="
                    showDocNameTooltip(props.row.process_file.attachment_name)
                  "
                  class="tooltip-break-word"
                  size="is-large"
                  multilined
                  role="tooltip"
                >
                  <div class="doc-name">
                    {{ props.row.process_file.attachment_name }}
                  </div>
                </b-tooltip>
                <p>
                  {{ General.TYPE }}:
                  <span class="has-text-weight-normal">{{
                    props.row.process_file.document_type !== null
                      ? props.row.process_file.document_type.type
                      : ""
                  }}</span>
                </p>
              </routerLink>

              <div class="has-text-color-8">
                <b-tooltip
                  :label="
                    props.row.capacity_request !== null
                      ? `${
                          props.row.capacity_request.entity.abbreviation
                        }/${props.row.capacity_request.abbreviation +
                          ' - ' +
                          props.row.capacity_request.description}`
                      : ''
                  "
                  :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
                  position="is-top"
                  :delay="500"
                  role="tooltip"
                >
                  <span>
                    <b class="has-text-weight-semibold">
                      {{ General.ASKED_BY }}
                    </b>
                    {{ props.row.user_request_name }}
                    <template v-if="props.row.capacity_request">
                      -
                      {{
                        props.row.capacity_request.entity.abbreviation +
                          "/" +
                          (props.row.capacity_request !== null
                            ? props.row.capacity_request.abbreviation.split(
                                "/",
                                -1
                              )[1]
                            : "")
                      }}</template
                    >
                  </span>
                </b-tooltip>
              </div>

              <div class="has-text-color-8">
                <span>
                  <b class="has-text-weight-semibold">
                    {{ General.PROCESS }}:
                  </b>
                  {{ props.row.process_file.process.subject || "" }}
                </span>
              </div>

              <BookmarkList :bookmarks="props.row.bookmarks" />
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="ordering_status"
            :label="General.STATUS"
            :sortable="!isMobile"
          >
            <span class="has-text-color-7">
              {{ getFileStatus(props.row.status) }}
            </span>
          </b-table-column>

          <b-table-column
            v-slot="props"
            field="created_at"
            :label="General.DATE"
            :sortable="!isMobile"
          >
            <div class="has-text-color-8">
              {{ new Date(props.row.date) | dateFormat("DD/MM/YYYY HH:mm:ss") }}
            </div>
          </b-table-column>

          <b-table-column
            v-slot="props"
            class="is-narrow"
            field="user.last_name"
            :label="General.ACTIONS"
          >
            <ActionsGrouper
              :actions="answeredActionList(props.row)"
              customClass=""
            />
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <NoListMessage v-if="!isLoading" />
            <b-loading v-else :isFullPage="false" :active="isLoading" />
          </section>
        </template>

        <template slot="footer">
          <div class="table-footer">
            <div class="column is-12 number-page pl-0">
              <span
                class="has-text-black column is-12 pl-0 has-text-weight-normal"
              >
                <b-dropdown
                  v-model="perPage"
                  role="listbox"
                  :expanded="isMobile"
                  position="is-top-right"
                >
                  <template slot="trigger">
                    <b-button
                      class="custom-dropdown-button custom-ph-8"
                      role="button"
                    >
                      <label
                        >{{ perPage }}
                        {{ General.PER_PAGE.toLowerCase() }}</label
                      >

                      <b-icon class="spacing-mx-5" icon="chevron-down" />
                    </b-button>
                  </template>
                  <div class="has-text-color-7 spacing-p-5 has-text-centered">
                    {{ General.RECORDS_FOR_PAGE }}
                    <div class="list-page">
                      <b-dropdown-item
                        v-for="option in getItensPage"
                        :key="option"
                        :value="option"
                        role="listitem"
                      >
                        <div>
                          {{ option }}
                        </div>
                      </b-dropdown-item>
                    </div>
                  </div>
                </b-dropdown>
              </span>
            </div>
            <div class="columns is-centered">
              <div class="column is-6">
                <b-pagination
                  :total="getDocumentSignedSignList.count"
                  :perPage="perPage"
                  :current.sync="currentPage"
                  rangeBefore="1"
                  rangeAfter="1"
                  order="is-centered"
                  class="process-panel-pagination"
                  rounded
                  :iconPrev="prevIcon"
                  :iconNext="nextIcon"
                  :aria-next-label="General.NEXT_PAGE"
                  :aria-previous-label="General.PREVIOUS_PAGE"
                  :aria-page-label="General.PAGE"
                  :aria-current-label="General.CURRENT_PAGE"
                  role="navigation"
                />
              </div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { debounce } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";

import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import {
  PROCESS_SIGNING_FILE_TABS as TABS,
  TAB_PERSIST_NAME as PERSIST_NAME,
  PROCESS_SUBJECT_ICONS as subjectIcons,
  SECRECY as secrecies
} from "@/utils/enumerate";

import UnifiedFilterSearch from "@/components/UnifiedFilterSearch";
import NoListMessage from "@/components/NoListMessage";
import BookmarkList from "@/components/BookmarkList.vue";
import { createFilterSignature } from "@/utils/filters";
import { formatPagination } from "@/utils/transformers";
import { setPersistSort, getPersistSort } from "@/plugins/indexDB";

export default {
  name: "SignatureAnswered",
  components: {
    UnifiedFilterSearch,
    NoListMessage,
    BookmarkList
  },
  data() {
    return {
      App,
      General,
      subjectIcons,
      sortField: "created_at",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      sortIcon: "menu-up",
      sortIconSize: "is-medium",
      currentPage: 1,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      perPage: 10,
      isLoading: true,
      observerPage: true,
      filterList: {},
      searchValue: "",
      documentsSelectedSigned: []
    };
  },
  computed: {
    ...mapGetters([
      "getDocumentSignedSignList",
      "getItensPage",
      "isContrast",
      "getCurrentTabSignPanel",
      "getUpdateBySockets",
      "getCurrentUser",
      "isMobile",
      "isConfidentialCheck"
    ]),
    activeTab() {
      return this.getCurrentTabSignPanel.value;
    },
    itensFilter() {
      return [
        "DOCUMENT_TYPE",
        "PROCESS_BOOKMARKS",
        "PROCESS_DATE",
        "PROCESS_CCS",
        "STATUS_SIGNATURE"
      ];
    },
    isValidSelection() {
      return this.documentsSelectedSigned.length < 2;
    },
    getPaginationDetails() {
      return formatPagination(
        this.getDocumentSignedSignList,
        this.currentPage,
        this.perPage,
        "SIMPLIFIED"
      );
    },
    requestBaseData() {
      return {
        page: this.currentPage,
        search: this.searchValue,
        order_by: this.sortField,
        ordenation: this.sortOrder,
        paginator_count: this.perPage,
        filters: createFilterSignature(this.filterList),
        ignore_order_by_default: this.ignoreOrderByDefault
      };
    },
    tabPersistName() {
      return `${PERSIST_NAME.SIGNING_SIGNED}_${this.getCurrentUser.id}`;
    },
    isCurrentTab() {
      return this.activeTab === TABS.SIGNING_SIGNED.value;
    }
  },
  watch: {
    perPage() {
      if (this.currentPage > 1) this.currentPage = 1;
      else this.updataSignatureList();
    },
    currentPage() {
      this.updataSignatureList();
    },
    getUpdateBySockets(value) {
      if (this.isCurrentTab && value === "update_signatures_answered") {
        this.currentPage = 1;
        this.getDocumentSign();
        this.clearUpdateBySockets();
      } else if (value === "update_signatures_answered") {
        this.documentSignedRequest({
          page: 1,
          only_count: true
        });
        this.clearUpdateBySockets();
      }
    },
    filterList: {
      handler() {
        this.updataSignatureList();
      },
      deep: true
    },
    activeTab() {
      if (this.isCurrentTab) {
        if (this.currentPage === 1) this.getDocumentSign();
        else this.currentPage = 1;
      }
    },
    getDocumentSignedSignList() {
      this.documentsSelectedSigned = [];
    },
    requestBaseData() {
      this.getDocumentSign();
    }
  },
  async created() {
    this.observerPage = false;
    const sortData = await getPersistSort({
      name: this.tabPersistName,
      sort: { [this.sortField]: this.sortOrder }
    });
    const sortString = JSON.stringify(sortData);
    if (sortString !== this.sortField) {
      this.sortOrder = Object.entries(sortData)[0];
      this.observerPage = true;
      this.onSort(...this.sortOrder);
    }
    this.observerPage = true;
  },
  async beforeMount() {
    if (this.isCurrentTab) this.getDocumentSign();
  },
  methods: {
    ...mapActions({ documentSignedRequest: "documentSignedRequest" }),
    ...mapMutations({ clearUpdateBySockets: "clearUpdateBySockets" }),
    updataSignatureList: debounce(function() {
      this.getDocumentSign();
    }, 500),
    setSearchValue: debounce(function(value) {
      this.searchValue = value;
      this.currentPage = 1;
    }, 500),
    setFilterList(filterList) {
      this.filterList = filterList;
      if (this.currentPage !== 1) this.currentPage = 1;
    },
    getDocumentSign: debounce(async function() {
      this.isLoading = true;
      if (this.isCurrentTab && this.observerPage)
        await this.documentSignedRequest(this.requestBaseData);
      this.isLoading = false;
    }, 1e3),
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.ignoreOrderByDefault = true;
      setPersistSort({ name: this.tabPersistName, sort: { [field]: order } });
      this.getDocumentSign();
    },
    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },
    showDocNameTooltip(docName) {
      return docName.length > 60;
    },
    answeredActionList(item) {
      return [
        {
          label: this.General.TO_VIEW,
          icon: "file-eye",
          link: `/app/documento/${item.process_file.id}?processId=${item.process_file.process.id}`
        }
      ];
    },
    getFileStatus(fileStatus) {
      const status = {
        PENDING: "Pendente",
        SIGNED: "Assinado",
        PARTIALLY: "Parcialmente",
        REFUSED: "Recusado"
      };
      return status[fileStatus] || "";
    },
    secrecyName(item) {
      const process = item.process_file.process;
      return (
        secrecies.find(secrecy => secrecy.id === process.secrecy).name || ""
      );
    },
    isConfidential(item) {
      const secrecyId = item.process_file.process.secrecy;
      return this.isConfidentialCheck(secrecyId);
    }
  }
};
</script>
